import { render } from "./OrganFormStep1.vue?vue&type=template&id=1eb9a572&scoped=true&lang=html"
import script from "./OrganFormStep1.vue?vue&type=script&lang=js"
export * from "./OrganFormStep1.vue?vue&type=script&lang=js"

import "./OrganFormStep1.vue?vue&type=style&index=0&id=1eb9a572&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb9a572"]])

export default __exports__